import { logger } from "../../infrastructure/services/LoggerService";
/**
 * Composable function to access logger in Vue Composition API
 * Can be used in setup() function or script setup
 *
 * @returns logger instance that implements ILogger interface
 *
 * @example
 * ```typescript
 * import { useLogger } from '@/shared/composables/useLogger';
 *
 * export default {
 *   setup() {
 *     const logger = useLogger();
 *     logger.debug("Debug message");
 *   }
 * }
 * ```
 */
export function useLogger() {
    return logger;
}
